import React from 'react'
import GLOBAL_CONFIG from '../../config'
export default class TotalBar extends React.Component {
  render(){
    let statusStyle = (this.props.status === GLOBAL_CONFIG.STATUS.DONE)
      ? 'success' : (this.props.status === GLOBAL_CONFIG.STATUS.ERROR)
        ? 'danger' : (this.props.status === GLOBAL_CONFIG.STATUS.RUNNING)
          ? 'warning' : 'info'
    return(
      <div>
          <div className='col-md-12'>
              <label className='pull-left' style = {{color: 'black'}}>{this.props.label}</label>
              <label className='pull-right' style = {{color: 'black'}}>{this.props.amount}</label>
          </div>
          <div className="col-md-12">
            <div className="progress progress-slim">
              <div className={`progress-bar progress-bar-${statusStyle}`} role="progressbar" aria-valuenow={this.props.percent} aria-valuemin="0" aria-valuemax="100" style={{width: `${this.props.percent}%`}}>
                <span className="sr-only">40% Complete (success)</span>
              </div>
            </div>
         </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/TotalBar.js